module.exports = {"title":"Sua Fatura","desktopText":"Ver todas as faturas","mobileText":"Ver mais"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/DashboardInvoiceWidget/data.json
// module id = 1916
// module chunks = 0